// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ab5df551","488":"fce3f22e","644":"3c123a53","732":"32904df9"}[chunkId] + ".chunk.js";
};